import { IssueContentType } from '@server-models';

export const issueCreateTypes = new Map<string, IssueContentType>([
  ['message', IssueContentType.Message],
  ['ticket', IssueContentType.Ticket],
  ['mission', IssueContentType.Mission],
  ['direct-message', IssueContentType.DirectMessage],
  ['connected', IssueContentType.Connected],
]);

export function getIssueCreateRoute(
  templateId: number | null | undefined,
  contentType: IssueContentType | null | undefined,
): string[] | undefined {
  const segment = [...issueCreateTypes].find(([, type]) => type === contentType)?.[0];
  return templateId && segment ? ['issues', segment, 'create', String(templateId)] : undefined;
}
